export const DEFAULT_IMG =
    "https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-alt-512.png";
